import { TabList } from "@mui/lab"
import { Box, styled } from "@mui/material"

export const UMTabsWrapper = styled(Box)({
  "& .MuiTabPanel-root": {
    padding: "0px",
  },
})

export const UMTabsList = styled(TabList)({
  // height: "5vh",
  color: "#706F70",
  marginLeft: "29px",
  ".MuiTab-root": {
    color: "#706F70",
    textTransform: "capitalize",
    fontSize: "16px",
    fontFamily: "Poppins",
    alignItems: "flex-start",
    padding: 0,
  },
  ".MuiTab-root.Mui-selected": {
    color: "#000000",
  },
  ".MuiTabs-indicator": {
    backgroundColor: "#3C77EF",
    maxWidth: "34px",
    height: "4px",
  },
})

// export sx={{ alignItems: "flex-start", margin: "0", padding: 0, color: "#000000" }}
